module.exports = __webpack_public_path__ + "static/media/1_01.6d08b42c.jpg";